import React from "react";
import styles from "./SectionTitle.module.scss";
import Icon from "../Icon";
import { icons } from "assets";

const SectionTitle = ({ text, onClick = null, expanded = false }) => {
  const containerStyles = [styles.sectionTitle];
  onClick && containerStyles.push(styles.cursorPointer);

  return (
    <>
      <div className={containerStyles.join(" ")} onClick={onClick}>
        {text}
        <div />

        {onClick && (
          <Icon icon={expanded ? icons.arrowRight : icons.arrowDown} />
        )}
      </div>
      
        {text === "groups"
          ? expanded
            ?<div
            className={[
              ...containerStyles,
              styles.multipleSelectionInfoMessage,
            ].join(" ")}
          > Use Crtl or shift to select multiple shots  </div>
            : null
          : null}
    
    </>
  );
};

export default SectionTitle;
